import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="50"
        height="50"
        viewBox="0 0 50 50"
      >
        <g fill="none" fillRule="nonzero">
          <path
            fill="#FF8B0C"
            fillOpacity=".254"
            d="M50 25c0 6.677-2.6 12.956-7.323 17.678C37.955 47.4 31.677 50 25 50c-6.678 0-12.955-2.6-17.677-7.322C2.6 37.956 0 31.678 0 25c0-6.678 2.6-12.956 7.323-17.678C12.045 2.6 18.323 0 25 0c6.678 0 12.955 2.6 17.677 7.322C47.4 12.044 50 18.322 50 25z"
          />
          <path
            fill="#FF8B0C"
            d="M44 25c0 10.477-8.524 19-19 19S6 35.477 6 25C6 14.524 14.524 6 25 6s19 8.524 19 19z"
          />
          <path
            fill="#FFF"
            d="M32.601 21.31l-7.1 7.043-1.276 1.265c-.015.015-.031.028-.047.042-.016.014-.03.03-.047.043l-.055.04c-.018.013-.034.027-.052.038-.018.013-.039.024-.058.035-.018.011-.035.023-.054.033-.02.01-.041.02-.061.028-.019.01-.036.018-.055.025-.022.01-.044.016-.067.025-.017.006-.035.013-.053.018-.024.008-.049.013-.073.018-.017.004-.033.01-.049.012-.029.006-.057.009-.086.012l-.039.007a1.232 1.232 0 0 1-.253 0l-.04-.007c-.029-.003-.058-.007-.087-.013l-.048-.012c-.025-.006-.052-.011-.076-.018l-.052-.02a1.027 1.027 0 0 1-.124-.051c-.021-.01-.043-.019-.064-.03l-.054-.033c-.02-.012-.04-.022-.06-.036l-.052-.04-.054-.04-.05-.046c-.015-.015-.03-.027-.045-.043l-3.983-4.06a1.363 1.363 0 0 1 0-1.902 1.302 1.302 0 0 1 1.867 0l3.062 3.12 2.184-2.166 5.259-5.216a1.303 1.303 0 0 1 1.867.026 1.364 1.364 0 0 1-.025 1.902z"
          />
        </g>
      </svg>
    )
  }
}

export default SvgFile



// WEBPACK FOOTER //
// ./src/Icons/SuccessLogo/SvgFile.js